<template>
  <div>
    <b-card bg-variant="white">
      <!-- <div class="search">
        <b-input v-model="searchTerm" placeholder="Search" class="mb-4" @input="search"/>
        <i class="fa fa-lg fa-search" aria-hidden="true"></i>
      </div> -->
      <div class="tutorial">
        <p>
          How-To Videos
        </p>
        <!-- <ul class="categories">
          <li v-for="c in categories" :key="c.id">
            <a
              :href="c.link"
              :class="[{'active': c.active}]"
              @click="changeCategory(c.id)"
            >{{ c.name }}</a>
          </li>
        </ul> -->
        <b-row>
          <div class="col-4 col-xxl-3" v-for="item in items" :key="item.id" >
            <b-card>
              <b-card-text>
                <div class="p-3">
                  <div class="embed-responsive embed-responsive-16by9">
                    <iframe class="embed-responsive-item" :src="item.src" allowfullscreen></iframe>
                  </div>
                </div>
                <div class="content">
                  <h6 class="font-weight-bold">{{ item.title }}</h6>
                  <p>
                    <code>{{ item.time }}</code> <br>
                    {{ item.description }}
                  </p>
                </div>
              </b-card-text>
            </b-card>
          </div>
        </b-row>

        <hr>

        <p>
          How-To Videos (Español)
        </p>

        <b-row>
          <div class="col-4 col-xxl-3" v-for="item in items_es" :key="item.id" >
            <b-card>
              <b-card-text>
                <div class="p-3">
                  <div class="embed-responsive embed-responsive-16by9">
                    <iframe class="embed-responsive-item" :src="item.src" allowfullscreen></iframe>
                  </div>
                </div>
                <div class="content">
                  <h6 class="font-weight-bold">{{ item.title }}</h6>
                  <p>
                    <code>{{ item.time }}</code> <br>
                    {{ item.description }}
                  </p>
                </div>
              </b-card-text>
            </b-card>
          </div>
        </b-row>
      </div>
    </b-card>
  </div>
</template>
<style lang="scss" scoped>
.search {
  position: relative;
  i {
    position: absolute;
    top: 11px;
    right: 8px;
  }
}
.tutorial {
  code {
    color: #273a83;
  }
  .categories {
    padding-left: 0;
    list-style: none;
    display: inline-flex;
    a {
      padding: 0.25rem 0.5rem;
      text-decoration: none;
      color: #212529;
      &.active {
        color: #fff;
        background-color: #273a83;
        border-color: #243679;
        padding: 0.25rem 0.5rem;
        font-size: 1rem;
        line-height: 1.5;
        border-radius: 3px;
      }
    }
  }
  .card {
    margin: .75rem auto;
    max-width: 20rem;
    height: 315px;
    .card-body {
      padding: 0;
      a {
        text-decoration: none;
        color: black;
        &:hover {
          color: black;
        }
      }
    }
    .content {
      padding: 0 1rem 1rem;
      p {
        font-size: .75rem;
      }
    }
  }
}
</style>
<script>
export default {
  data () {
    return {
      searchTerm: '',
      categories: [
        {
          id: 1,
          name: 'Overview',
          link: '/#/help/how-to',
          active: true,
        },
        {
          id: 2,
          name: 'View',
          link: '/#/help/how-to',
        },
        {
          id: 3,
          name: 'Task',
          link: '/#/help/how-to',
        },
      ],
      items: [
        {
          id: 1,
          title: "How To Print a Domestic Label with Grandshipper",
          time: "2:28",
          src: "https://www.youtube.com/embed/njttmkSSVxo",
          description: "This video will show you how to easily print a domestic label in three different ways."
        },
        {
          id: 2,
          title: "How To Print an International Label with Grandshipper",
          time: "2:50",
          src: "https://www.youtube.com/embed/NruAKAjm6dM",
          description: "This video will explain in detail how you can print an International Label with GrandShipper."
        },
        {
          id: 3,
          title: "How To Void a Label with Grandshipper",
          time: "1:05",
          src: "https://www.youtube.com/embed/TkigFSdqorE",
          description: "This video will explain how you can easily void/cancel/refund a label that you have processed through GrandShipper."
        },
      ],
      cloned_items: [],
      items_es: [
        {
          id: 1,
          title: "Cómo imprimir una etiqueta nacional con GrandShipper",
          time: "2:28",
          src: "https://www.youtube.com/embed/RhQH9_NaSos",
          description: "Cómo imprimir una etiqueta nacional con GrandShipper"
        },
        {
          id: 2,
          title: "Cómo Imprimir Una Etiqueta Internacional con GrandShipper",
          time: "2:50",
          src: "https://www.youtube.com/embed/6PFIbpJSSBc",
          description: "Cómo Imprimir Una Etiqueta Internacional con GrandShipper"
        },
        {
          id: 3,
          title: "Cómo Anular Una Etiqueta con GrandShipper",
          time: "1:05",
          src: "https://www.youtube.com/embed/_xEC5fcCe0w",
          description: "Cómo Anular Una Etiqueta con GrandShipper"
        },
      ]
    };
  },
  mounted() {
    this.cloned_items = _.cloneDeep(this.items);
  },
  methods: {
    changeCategory(id) {
      this.categories = this.categories.map(c => {
        c.active = (c.id === id) ? true : false;
        return c;
      })
    },
    search(val) {
      if (val) {
        val = val.toLowerCase();
        this.items = this.cloned_items.map(item => {
          const title = item.title.toLowerCase();
          const description = item.description.toLowerCase();
          if (title.indexOf(val) > -1 || description.indexOf(val) > -1) {
            return item;
          }
        }).filter(i => i !== undefined);
      } else {
        this.items = this.cloned_items;
      }
    }
  },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/views/Help/Tutorials.vue